module.exports = __webpack_public_path__ + "img/rl-second6.125dc405.png";